import React from 'react';

import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import linkedinblack from '../../images/icons/linkedin-black.png';
import mediumblack from '../../images/icons/medium-black.png';
import githubblack from '../../images/icons/github-black.png';

const FooterStyled = styled.div`
    overflow: hidden;
    .footer {
        min-height: 10vh;
        width: 100vw;
        background-color: var(--themecolora);
        color: var(--backgroundb);
        position: relative;
        text-align: center;
        font-size: var(--fontsizefooter);
        padding: 2vh var(--marginborder) 2.5vh;
        box-sizing: border-box;

        @media (min-width: 1023px) {
            /* Clear fixed bottom border bar */
            padding-bottom: calc(2.5vh + var(--marginborder) + 1vh);
        }
    }
    .footer-social {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 3vh;
        margin-bottom: 1.2vh;
    }
    .footer-social a {
        display: block;
        line-height: 0;
    }
    .footer-social .linkedin,
    .footer-social .medium,
    .footer-social .github {
        width: 2vh;
        height: 2vh;
        min-width: 14px;
        min-height: 14px;
        background-color: transparent;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        filter: brightness(0) invert(1);
    }
    .footer-social .linkedin {
        background-image: url(${linkedinblack});
    }
    .footer-social .medium {
        background-image: url(${mediumblack});
    }
    .footer-social .github {
        background-image: url(${githubblack});
    }
    .footer-text {
        margin: 0;
    }
`;

function FooterSection({ theref }) {
    const [t] = useTranslation();
    const year = new Date().getFullYear();

    return (
        <FooterStyled>
            <div className="footer" ref={theref}>
                <div className="footer-social">
                    <a
                        href="https://www.linkedin.com/in/alex-sze/"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="LinkedIn"
                    >
                        <div className="linkedin" />
                    </a>
                    <a
                        href="https://medium.com/@alexyysze"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="Medium"
                    >
                        <div className="medium" />
                    </a>
                    <a
                        href="https://github.com/AlexSze"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="GitHub"
                    >
                        <div className="github" />
                    </a>
                </div>
                <p className="footer-text">{t('Footer.footer', { year })}</p>
            </div>
        </FooterStyled>
    );
}

export default FooterSection;
